import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React base styles
import "react-best-tabs/dist/index.css";
import Tabs, { Tab } from "react-best-tabs";
import "../../style.css";

import ProfileInformation from "../components/ProfileInformation.js";
import NotificationPreferences from "../components/NotificationPreference.js";
import { getCustomerAPI } from "../_request";
import { useAuth } from "context";

import { Box, Avatar, Typography, Card } from "@mui/material";
import profileImg from "../../../assets/images/icons/catering-icons/profileIcon.svg";

function Header() {
  const { setVerifiedCustomer } = useAuth();
  const [customer, setCustomer] = useState();
  const [workEmail, setWorkEmail] = useState({
    email: "",
    isOTPVisible: false,
    otpNumber: "",
    isVerified: false,
    linkedAccountId: null,
  });
  const [customerDataLoader, setCustomerDataLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [tabKey, setTabKey] = useState(0);

  const handleProgrammaticNav = (index) => {
    setActiveTab(index);
    setTabKey((prev) => prev + 1);
  };

  const getCustomerDetails = async () => {
    try {
      setCustomerDataLoader(true);
      const {
        data: { success, data },
      } = await getCustomerAPI({ includeCredentials: true });
      if (success) {
        setCustomer({
          id: data.customer.id,
          firstName: data.customer.firstName,
          lastName: data.customer.lastName,
          email: data.customer.email,
          verifiedAt: data.customer.verifiedAt,
          phoneVerifiedAt: data.customer.phoneVerifiedAt,
          phoneCountryCode: data.customer.phoneCountryCode,
          phoneNumber: data.customer.phoneNumber,
          isPass: data.customer.isPass,
          notification_preferences: data.customer.notification_preferences,
        });

        // Sync verification status
        setVerifiedCustomer((prev) => ({
          ...prev,
          verifiedAt: data.customer.verifiedAt,
          phoneVerifiedAt: data.customer.phoneVerifiedAt,
        }));

        // If customer has any linked accounts, take the first one
        if (
          data.customer.customer_linked_accounts &&
          data.customer.customer_linked_accounts.length > 0
        ) {
          const account = data.customer.customer_linked_accounts[0];
          setWorkEmail({
            email: account.email,
            isOTPVisible: true,
            otpNumber: "",
            isVerified: account.verifiedAt !== null,
            linkedAccountId: account.id,
          });
        } else {
          // Reset work email if no linked accounts
          setWorkEmail({
            email: "",
            isOTPVisible: false,
            otpNumber: "",
            isVerified: false,
            linkedAccountId: null,
          });
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCustomerDataLoader(false);
    }
  };

  useEffect(() => {
    getCustomerDetails();
  }, []);

  return (
    <Card
      sx={{
        p: 4,
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        "@media (max-width:767px)": {
          p: 2,
        },
      }}
    >
      {/* Profile Header with Avatar */}
      <Box
        sx={{
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Avatar
          src={profileImg}
          alt="Profile"
          sx={{
            width: 64,
            height: 64,
            border: "1px solid #e0e0e0",
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "18px", md: "22px" },
            lineHeight: 1.4,
          }}
        >
          {customer?.firstName} {customer?.lastName}
        </Typography>
      </Box>

      <Tabs
        key={tabKey}
        activeTab={activeTab}
        onClick={(index) => setActiveTab(index)}
        ulClassName="text-muted dark-border setting-tabs"
        activityClassName="bg-primary"
      >
        <Tab
          title="Profile Information"
          className="mt-2 text-xs md:text-[15px] font-medium text-center"
        >
          <ProfileInformation
            customer={customer}
            setCustomer={setCustomer}
            workEmail={workEmail}
            setWorkEmail={setWorkEmail}
            customerDataLoader={customerDataLoader}
            getCustomerDetails={getCustomerDetails}
          />
        </Tab>
        <Tab
          title="Notification Preference"
          className="mt-2 text-xs md:text-[15px] font-medium text-center"
        >
          <NotificationPreferences
            customer={customer}
            customerDataLoader={customerDataLoader}
            onChangeTab={handleProgrammaticNav}
          />
        </Tab>
      </Tabs>
    </Card>
  );
}

export default Header;
